<template>
    <!-- <Link :href="route('checkout')" v-show="cartCount" class="bg-green p-2"> -->
    <jet-button :href="route('checkout')" v-show="cartCount || isAdmin" class="text-center flex justify-between items-center gap-x-2">
        <img src="/images/icons/shopping-cart.svg" width="20" height="20" alt="Cart" class="mx-auto" />
        <p v-if="!isAdmin" class="text-white text-sm leading-tight">{{ toCurrency(cartTotal) }}</p>
        <p v-if="!isAdmin" class="text-white text-sm leading-tight">({{ cartCount }})</p>
    </jet-button>
</template>

<script>
import { Link, usePage } from '@inertiajs/inertia-vue3';
import UseCart from '@/Composables/UseCart';
import JetButton from '@/Jetstream/Button';
import UseUserAuth from '@/Composables/UseUserAuth';

export default {
    setup (props) {
        const { isAdmin } = UseUserAuth(usePage().props.value.user);
        const { cartTotal, cartCount } = 
            UseCart(
                usePage().props.value.user,
                usePage().props.value.activeCustomer ? usePage().props.value.activeCustomer.tax_exempt : 0
            );

        return {
            cartTotal,
            cartCount,
            isAdmin,
        }
    },

    components: {
        JetButton,
        Link,
    }
}
</script>

<style>

</style>